import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const REVERT_REPLACE_LOCATION_TYPE_MUTATION = gql`
  mutation revertReplaceLocationType($replaceToken: String!) {
    revertReplaceLocationType(replaceToken: $replaceToken) {
      results {
        ...LocationTypeCategoryNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REVERT_REPLACE_LOCATION_TYPE_MUTATION
